export default "__VITE_ASSET__Cs80GTlD__"